import { About } from '../../components/About';
import { Contact } from '../../components/Contact';
import { DataHome } from '../../components/DataHome';
import { Footer } from '../../components/Footer';
import { Portfolio } from '../../components/Portfolio';
import { ProfileHero } from '../../components/ProfileHero';
import { ScrollDown } from '../../components/ScrollDown';
import { Skills } from '../../components/Skills';
import { Social } from '../../components/Socials';
import { Testimonials } from '../../components/Testimonials';
import { ContainerHome, SectionHome, GridHome } from './styles';

export function Home() {
    return (
        <>
            <SectionHome id='home'>
                <ContainerHome>
                    <GridHome>
                        <Social />
                        <DataHome />
                        <ProfileHero />
                    </GridHome>
                    <ScrollDown />
                </ContainerHome>
            </SectionHome>
            <About />

            <Skills />


            <Portfolio />

            <Testimonials/>

            <Contact />

            <Footer/>
        </>
    )
}